import axios from 'api/axios'

export interface GetWalletReportParam {
	should_export?: 'YES'
	size: number
	page: number
}

export interface GetWalletReportRecord {
	_id: string
	organizationName: string
	wallet: {
		_id: string
		amount: {
			credit: number
			reserve: number
		}
	}
}
export interface GetWalletReportResponse {
	totalCount: number
	totalPages: number
	currentPage: number
	records: GetWalletReportRecord[]
}
const getWalletReport = async (
	params: GetWalletReportParam
): Promise<GetWalletReportResponse> => {
	const response = await axios.get<GetWalletReportResponse>(
		'v1/client/management/wallet-balance/report',
		{ params }
	)
	return response.data
}
export default getWalletReport
